import {styled} from "@mui/material/styles";
import { Chip, FormControl, FormControlLabel } from "@mui/material";
import { BaseAutocomplete } from "../../styles/GlobalStyle";

export const CustomFormControl = styled(FormControl)(() => ({
    '& .Mui-disabled': {
        backgroundColor: 'transparent'
    }
}));

export const CustomAutocomplete = styled(BaseAutocomplete)(() => ({
}))

export const CustomChip = styled(Chip)(({ theme }) => {
  	return {
		background: "#e1ecf7",
		'.MuiSvgIcon-root': {
			fontSize: 14,
			color: '#565657ff',
            marginLeft: 1,
		},
		'.MuiChip-label': {
			paddingLeft: 9,
			paddingRight: 9,
			fontWeight: 'bold',
			color: '#464646ff',
		},
        color: "#565657ff",
        borderRadius: 8,
        fontWeight: 'bold',
        fontSize: '14px',
		[theme.breakpoints.down('md')]: {
			fontSize: '12px',
		},
	}
})

export const ControlLabel = styled(FormControlLabel)(({ theme }) => {
  	return {
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
      },
      [theme.breakpoints.down('md')]: {
        '& .MuiFormControlLabel-label': {
          fontSize: '12px',
        },
      },
	  }
})
